export const CREATE_NEW_COLLECTION_KEY = "create-new-collection";
export const BATCH_SIZE = 5;
